// Author thq
// Date 2021-12-05 20:12:56

import * as model from "@/model/em/spareparts/EmSppRequisitionRwoSrrModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.EmSppRequisitionRwoSrr(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_EM_SPAREPARTS_URL,
    })
    .buildStore()
